import { useState } from 'react';

const NAV_ITEMS = [
  { label: '今日焦点', href: '#focus' },
  { label: '线索追踪', href: '#thread' },
  { label: '热度榜', href: '#rank' },
  { label: '动态聚合', href: '#feed' },
  { label: '线索投稿', href: '#submit' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header id="top" className="relative z-50">
      <div className="bg-foreground-950 text-background-200">
        <div className="mx-auto flex h-9 max-w-[1440px] items-center justify-between px-4 text-xs md:px-8">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-calendar-line text-background-400" />
              2026年9月10日 星期四
            </span>
            <span className="hidden h-3 w-px bg-background-50/20 sm:block" />
            <span className="hidden whitespace-nowrap text-background-400 sm:block">
              黑料51 · 资讯聚合 · 持续翻新
            </span>
          </div>
          <div className="flex items-center gap-4">
            <span className="hidden items-center gap-1.5 whitespace-nowrap md:flex">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500 hl-pulse" />
              今日已更新 <strong className="font-label text-accent-400">128</strong> 条
            </span>
            <a href="#rank" className="hidden whitespace-nowrap text-background-300 transition-colors hover:text-accent-400 sm:block">
              热度榜
            </a>
            <a href="#submit" className="whitespace-nowrap text-background-300 transition-colors hover:text-accent-400">
              线索投稿
            </a>
          </div>
        </div>
      </div>

      <nav className="sticky top-0 border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between gap-6 px-4 md:h-[72px] md:px-8">
          <div className="flex items-center gap-8">
            <h1 className="flex-none">
              <a href="#top" className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-label text-base font-bold text-background-50">
                  51
                </span>
                <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
                  黑料51
                </span>
              </a>
            </h1>
            <div className="hidden items-center gap-7 md:flex">
              {NAV_ITEMS.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-3">
            <label className="hidden items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2 lg:flex">
              <i className="ri-search-line text-base text-foreground-400" />
              <input
                type="text"
                placeholder="搜关键词 / 动态 / 线索"
                className="w-44 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </label>
            <a
              href="#submit"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:block"
            >
              我要投稿
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            <div className="flex flex-col">
              {NAV_ITEMS.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="border-b border-background-100 py-3 text-sm font-medium text-foreground-800 last:border-0"
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#submit"
                onClick={() => setOpen(false)}
                className="mt-3 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-center text-sm font-medium text-background-50"
              >
                我要投稿
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}